import * as Sentry from '@sentry/nextjs';

// Reporte de errores del navegador a GlitchTip (instancia propia de Kemeny).
// El DSN es público por diseño (viaja a todos los navegadores), por eso va
// hardcodeado y no por variable de entorno. Solo en producción: los errores
// de desarrollo son ruido.
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://62c438ec999a4917a8b0bf65f67abf26@glitchtip.kemenylabs.com/4',
    tracesSampleRate: 0,
  });
}
